/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactWithPendingChangesetResponseDtoSchema } from "../contactWithPendingChangesetResponseDtoSchema";
import { z } from "zod/v4";

export const getContactWithPendingChangesetPathParamsSchema = z.object({
    "contactId": z.uuid()
    })

export const getContactWithPendingChangesetHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Core contact fields plus preview of updates from pending contact field signals
 */
export const getContactWithPendingChangeset200Schema = z.lazy(() => contactWithPendingChangesetResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const getContactWithPendingChangeset401Schema = z.any()

export const getContactWithPendingChangesetQueryResponseSchema = z.lazy(() => getContactWithPendingChangeset200Schema)